export default __webpack_public_path__ + "static/media/EAST1010.34I-34108_-18351_0.edd13f0d.jpg";